import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import "./CubeLink.css";

class CubeLink extends Component {
  render() {
    return (
      <Link className="cube-link" to={this.props.href}>
        <div className="inner-cube">
          <div className="flippety">
            <strong>{this.props.face1}</strong>
          </div>
          <div className="flop">
            <small>{this.props.face2}</small>
          </div>
        </div>
      </Link>
    );
  }
}

class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      open: false,
      closeHover: false
    };

    this.openNav = this.openNav.bind(this);
    this.closeNav = this.closeNav.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentWillMount() {
    window.addEventListener("resize", this.handleWindowSizeChange);
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleWindowSizeChange);
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  handleScroll = () => {
    this.setState({
      open: false
    });
  };
  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({
        open: false
      });
    }
  };
  setWrapperRef(node) {
    this.wrapperRef = node;
  }
  openNav() {
    this.setState({
      open: true
    });
  }
  closeNav() {
    this.setState({
      open: false
    });
  }

  closeHover() {
    this.setState({
      closeHover: true
    });
  }

  closeNotHover() {
    this.setState({
      closeHover: false
    });
  }

  render() {
    const { width, closeHover } = this.state;
    const isMobile = width <= 991;
    let navbar = {};

    if (isMobile) {
      navbar = (
        <nav style={{ background: this.props.color }}>
          <div ref={this.setWrapperRef} className="nav-wrapper container">
            <Link className="nav-text-name center brand-logo" to="/">
              Nick Smith
            </Link>
            <a className="button-collapse" onClick={this.openNav}>
              <i className="material-icons">menu</i>
            </a>
            <ul
              className={`side-nav ${this.state.open ? "visible" : "hidden"}`}
              tabIndex="0"
              onBlur={this.closeNav}
            >
              <li className="nav-li">
                <a
                  className="nav-text"
                  onClick={this.closeNav}
                  onMouseEnter={this.closeHover.bind(this)}
                  onMouseLeave={this.closeNotHover.bind(this)}
                >
                  <i
                    className={`${
                      closeHover ? "white-color" : "black-color"
                    } material-icons left sideNavClose`}
                  >
                    close
                  </i>
                </a>
              </li>
              <li>
                <Link className="nav-text" onClick={this.closeNav} to="/work">Work</Link>
              </li>
              <li>
                <Link className="nav-text" onClick={this.closeNav} to="/about">About</Link>
              </li>
              <li>
                <Link className="nav-text" onClick={this.closeNav} to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
        </nav>
      );
    } else {
      navbar = (
        <nav style={{ background: this.props.color }}>
          <div className="nav-wrapper container">
            <Link className="nav-text-name" to="/">
              Nicholas P Smith
            </Link>
            <ul className="right hide-on-sm-and-down main-nav">
              {/* <li className="nav-li">
                <CubeLink href={"/"} face1="Home" face2="Go Home" />
              </li> */}
              <li className="nav-li">
                <CubeLink href={"/work"} face1="Work" face2="My Work" />
              </li>
              <li>
                <CubeLink href={"/about"} face1="About" face2="About Me" />
              </li>
              <li>
                <CubeLink href={"/contact"} face1="Contact" face2="Contact Me" />
              </li>
            </ul>
          </div>
        </nav>
      );
    }

    return <div className="navbar-fixed">{navbar}</div>;
  }
}

export default withRouter(NavBar)


// WEBPACK FOOTER //
// ./src/components/navbar.js